import app from "firebase/app";
import "firebase/auth";
import "firebase/firebase-firestore";

const config = {
  apiKey: "AIzaSyD40tjm34_l_Jb_ISAisneZSoX9uCUOnjA",
  authDomain: "inspire-graphics.firebaseapp.com",
  databaseURL: "https://inspire-graphics.firebaseio.com",
  projectId: "inspire-graphics",
  storageBucket: "inspire-graphics.appspot.com",
  messagingSenderId: "911098121057",
  appId: "1:911098121057:web:a420c2dda0c060c7c6d320",
  measurementId: "G-T3FM4NLNK0",
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.auth = app.auth();
    this.db = app.firestore();
    this.storage = app.storage();
  }

  login(email, password) {
    return this.auth.signInWithEmailAndPassword(email, password);
  }

  logout() {
    return this.auth.signOut();
  }

  async register(name, email, password) {
    await this.auth.createUserWithEmailAndPassword(email, password);
    return this.auth.currentUser.updateProfile({
      displayName: name,
    });
  }

  addQuote(quote) {
    if (!this.auth.currentUser) {
      return alert("Not authorized");
    }

    return this.db
      .doc(`users_codedamn_video/${this.auth.currentUser.uid}`)
      .set({
        quote,
      });
  }

  isInitialized() {
    return new Promise((resolve) => {
      this.auth.onAuthStateChanged(resolve);
    });
  }

  currentUser() {
    return new Promise((resolve) => {
      this.auth.onAuthStateChanged(() => {
        resolve(this.auth.currentUser);
      });
    });
    // return this.auth.currentUser && this.auth.currentUser;
  }

  getCurrentUsername() {
    return this.auth.currentUser && this.auth.currentUser.displayName;
  }

  async updataUser(name) {
    return this.auth.currentUser.updateProfile({
      displayName: name,
    });
  }

  async uploadByFile(file) {
    return new Promise((response, resolve) => {
      const name = this.auth.currentUser.uid;
      const uploadTask = this.storage.ref(`blog/temp/${name}.jpeg`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          // setProgress(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          this.storage
            .ref("blog/temp")
            .child(`${name}.jpeg`)
            .getDownloadURL()
            .then((url) => {
              response(url);
            });
        }
      );
    });
  }

  async updateProfileImg(image) {
    const name = this.auth.currentUser.uid;
    const uploadTask = this.storage.ref(`users/${name}.jpeg`).put(image);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        // setProgress(progress);
      },
      (error) => {
        console.log(error);
      },
      () => {
        this.storage
          .ref("users")
          .child(`${name}.jpeg`)
          .getDownloadURL()
          .then((url) => {
            this.auth.currentUser
              .updateProfile({
                photoURL: url,
              })
              .then(() => {
                console.log("Profile updated successfully..");
              });
          });
      }
    );
  }
  writeToUs(data) {
    this.db.collection("write-to-us").add({
      name: data.name,
      email: data.email,
      phone: data.phoneNumber,
      subject: data.subject,
      message: data.description,
    });
  }

  async getCurrentUserQuote() {
    const quote = await this.db
      .doc(`users_codedamn_video/${this.auth.currentUser.uid}`)
      .get();
    return quote.get("quote");
  }
}

export default new Firebase();
